module.exports = __webpack_public_path__ + "static/img/p1.83eca31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robot/LM2/p1.png
// module id = 3Jak
// module chunks = 7